import './label.css';
export default {
  "button": "pf-v5-c-button",
  "label": "pf-v5-c-label",
  "labelActions": "pf-v5-c-label__actions",
  "labelContent": "pf-v5-c-label__content",
  "labelIcon": "pf-v5-c-label__icon",
  "labelText": "pf-v5-c-label__text",
  "modifiers": {
    "compact": "pf-m-compact",
    "blue": "pf-m-blue",
    "green": "pf-m-green",
    "orange": "pf-m-orange",
    "red": "pf-m-red",
    "purple": "pf-m-purple",
    "cyan": "pf-m-cyan",
    "gold": "pf-m-gold",
    "outline": "pf-m-outline",
    "overflow": "pf-m-overflow",
    "add": "pf-m-add",
    "editable": "pf-m-editable",
    "editableActive": "pf-m-editable-active",
    "disabled": "pf-m-disabled"
  },
  "themeDark": "pf-v5-theme-dark"
};